import { Component } from '@angular/core';
import { Helpers } from '../../../helpers/helpers';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})

export class FooterComponent {

  isInDevEnvironment = false;

  constructor(private helper: Helpers, private clipboard: Clipboard) { }

  ngOnInit(): void {
    this.isInDevEnvironment = this.helper.isInDevEnvironment();
  }

  toggleDevStyleClass() {
    if (this.isInDevEnvironment) {
      let body = document.getElementsByTagName('body')[0];
      if (body.classList.contains('dev-environment')) {
        body.classList.remove('dev-environment');
      } else {
        body.classList.add('dev-environment');
      }
    }
  }

  helpEmail() {
    this.clipboard.copy('apoio_local@stihl.pt');
  }

}
